import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createPlan } from '../api/plans';
import { HttpError } from '../api/client';

export function PlanNewPage() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const plan = await createPlan({
        title: title.trim(),
        description: description.trim() || null,
      });
      navigate(`/plans/${plan.id}`, { replace: true });
    } catch (err) {
      setError(err instanceof HttpError ? err.apiError.message : 'Errore di connessione');
      setSubmitting(false);
    }
  }

  return (
    <div className="page">
      <div className="page-head">
        <h1>Nuova pianificazione</h1>
        <Link to="/plans" className="btn btn-ghost">
          ← Annulla
        </Link>
      </div>
      <form className="form-card" onSubmit={onSubmit}>
        <label>
          <span>Titolo *</span>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            autoFocus
            maxLength={200}
            placeholder="es. Idea Sardegna primavera"
          />
        </label>
        <label>
          <span>Descrizione</span>
          <textarea
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={5000}
            placeholder="appunti, riferimenti, idee…"
          />
        </label>
        {error && <p className="err">{error}</p>}
        <div className="actions">
          <button type="submit" disabled={submitting || !title.trim()}>
            {submitting ? 'Creazione…' : 'Crea pianificazione'}
          </button>
        </div>
      </form>
    </div>
  );
}
